<h3 mat-dialog-title>DP Events</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Event</mat-label>
            <input matInput type="text" name="name" [(ngModel)]="trailDocumentDpEvent.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Explanation</mat-label>
            <textarea matInput type="text" name="explanation" [(ngModel)]="trailDocumentDpEvent.explanation"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark</mat-label>
            <textarea matInput type="text" name="remark" [(ngModel)]="trailDocumentDpEvent.remark"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailDocumentDpEvent" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>

